import { supabase } from '../supabaseClient';
import { mapRequest } from '../lib/helpers';

const toDb = (r, includeId = true) => {
  const row = {
    asset_id:          r.assetId          || r.asset_id,
    asset_name:        r.assetName        || r.asset_name,
    epc:               r.epc,
    inventory_number:  r.inventoryNumber  || r.inventory_number,
    from_facility_id:  r.fromFacilityId   || r.from_facility_id,
    from_facility_name: r.fromFacilityName || r.from_facility_name,
    to_facility_id:    r.toFacilityId     || r.to_facility_id,
    to_facility_name:  r.toFacilityName   || r.to_facility_name,
    requested_by:      r.requestedBy      || r.requested_by,
    reason:            r.reason,
    status:            r.status,
    priority:          r.priority,
    approved_by:       r.approvedBy       || r.approved_by  || null,
    delivery_id:       r.deliveryId       || r.delivery_id  || null,
    notes:             r.notes,
    requested_at:      r.requestedAt      || r.requested_at || new Date().toISOString(),
    updated_at:        r.updatedAt        || r.updated_at,
    org_id:            r.org_id           || r.orgId,
  };
  if (includeId && r.id) row.id = r.id;
  return row;
};

export const requestsService = {

  async getAll() {
    const { data, error } = await supabase
      .from('requests')
      .select('*')
      .order('requested_at', { ascending: false });
    if (error) throw error;
    return data.map(mapRequest);
  },

  async create(req) {
    const { data, error } = await supabase
      .from('requests')
      .insert([toDb(req, false)])
      .select()
      .single();
    if (error) throw error;
    return mapRequest(data);
  },

  async update(id, changes) {
    const dbChanges = {
      ...(changes.status      !== undefined && { status:       changes.status }),
      ...(changes.approved_by !== undefined && { approved_by:  changes.approved_by }),
      ...(changes.approvedBy  !== undefined && { approved_by:  changes.approvedBy }),
      ...(changes.delivery_id !== undefined && { delivery_id:  changes.delivery_id }),
      ...(changes.deliveryId  !== undefined && { delivery_id:  changes.deliveryId }),
      ...(changes.notes       !== undefined && { notes:        changes.notes }),
      updated_at: new Date().toISOString(),
    };
    const { data, error } = await supabase
      .from('requests')
      .update(dbChanges)
      .eq('id', id)
      .select()
      .single();
    if (error) throw error;
    return mapRequest(data);
  },

  async updateStatus(id, status, approvedBy) {
    const { data, error } = await supabase
      .from('requests')
      .update({ status, approved_by: approvedBy, updated_at: new Date().toISOString() })
      .eq('id', id)
      .select()
      .single();
    if (error) throw error;
    return mapRequest(data);
  },

  async linkDelivery(requestId, deliveryId) {
    const { error } = await supabase
      .from('requests')
      .update({ delivery_id: deliveryId })
      .eq('id', requestId);
    if (error) throw error;
  },
};
